namespace Matrix.Indexation {
    export interface FactCompositeConstituentRow {
        IndexationProfileKey?: number;
        CompositeIndexKey?: number;
        ConstituentIndexKey?: number;
        Weight?: number;
        HedgeRatio?: number;
        DefaultSortOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        CompositeIndexCode?: string;
        CompositeIndexName?: string;
        CompositeIndexGeneration?: number;
        CompositeIndexIsCurrent?: string;
        CompositeIndexEffectiveFrom?: string;
        CompositeIndexEffectiveTo?: string;
        CompositeIndexLocalCurrencyCode?: string;
        CompositeIndexTypeCode?: string;
        CompositeIndexPriceSource1?: string;
        CompositeIndexPriceSource1Id?: string;
        CompositeIndexPriceSource2?: string;
        CompositeIndexPriceSource2Id?: string;
        CompositeIndexFxOtherCurrency?: string;
        CompositeIndexRowId?: number;
        ConstituentIndexCode?: string;
        ConstituentIndexName?: string;
        ConstituentIndexGeneration?: number;
        ConstituentIndexIsCurrent?: string;
        ConstituentIndexEffectiveFrom?: string;
        ConstituentIndexEffectiveTo?: string;
        ConstituentIndexLocalCurrencyCode?: string;
        ConstituentIndexTypeCode?: string;
        ConstituentIndexPriceSource1?: string;
        ConstituentIndexPriceSource1Id?: string;
        ConstituentIndexPriceSource2?: string;
        ConstituentIndexPriceSource2Id?: string;
        ConstituentIndexFxOtherCurrency?: string;
        ConstituentIndexRowId?: number;
    }

    export namespace FactCompositeConstituentRow {
        export const idProperty = 'IndexationProfileKey';
        export const localTextPrefix = 'Indexation.FactCompositeConstituent';
        export const deletePermission = 'DataAdmin:FactCompositeConstituent';
        export const insertPermission = 'DataAdmin:FactCompositeConstituent';
        export const readPermission = 'Read:FactCompositeConstituent';
        export const updatePermission = 'DataAdmin:FactCompositeConstituent';

        export declare const enum Fields {
            IndexationProfileKey = "IndexationProfileKey",
            CompositeIndexKey = "CompositeIndexKey",
            ConstituentIndexKey = "ConstituentIndexKey",
            Weight = "Weight",
            HedgeRatio = "HedgeRatio",
            DefaultSortOrder = "DefaultSortOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            CompositeIndexCode = "CompositeIndexCode",
            CompositeIndexName = "CompositeIndexName",
            CompositeIndexGeneration = "CompositeIndexGeneration",
            CompositeIndexIsCurrent = "CompositeIndexIsCurrent",
            CompositeIndexEffectiveFrom = "CompositeIndexEffectiveFrom",
            CompositeIndexEffectiveTo = "CompositeIndexEffectiveTo",
            CompositeIndexLocalCurrencyCode = "CompositeIndexLocalCurrencyCode",
            CompositeIndexTypeCode = "CompositeIndexTypeCode",
            CompositeIndexPriceSource1 = "CompositeIndexPriceSource1",
            CompositeIndexPriceSource1Id = "CompositeIndexPriceSource1Id",
            CompositeIndexPriceSource2 = "CompositeIndexPriceSource2",
            CompositeIndexPriceSource2Id = "CompositeIndexPriceSource2Id",
            CompositeIndexFxOtherCurrency = "CompositeIndexFxOtherCurrency",
            CompositeIndexRowId = "CompositeIndexRowId",
            ConstituentIndexCode = "ConstituentIndexCode",
            ConstituentIndexName = "ConstituentIndexName",
            ConstituentIndexGeneration = "ConstituentIndexGeneration",
            ConstituentIndexIsCurrent = "ConstituentIndexIsCurrent",
            ConstituentIndexEffectiveFrom = "ConstituentIndexEffectiveFrom",
            ConstituentIndexEffectiveTo = "ConstituentIndexEffectiveTo",
            ConstituentIndexLocalCurrencyCode = "ConstituentIndexLocalCurrencyCode",
            ConstituentIndexTypeCode = "ConstituentIndexTypeCode",
            ConstituentIndexPriceSource1 = "ConstituentIndexPriceSource1",
            ConstituentIndexPriceSource1Id = "ConstituentIndexPriceSource1Id",
            ConstituentIndexPriceSource2 = "ConstituentIndexPriceSource2",
            ConstituentIndexPriceSource2Id = "ConstituentIndexPriceSource2Id",
            ConstituentIndexFxOtherCurrency = "ConstituentIndexFxOtherCurrency",
            ConstituentIndexRowId = "ConstituentIndexRowId"
        }
    }
}
